import React, { useState } from 'react';

const AdminResponse = ({ responses, readNotifications, setReadNotifications, onMarkAsRead }) => {
    const [expanded, setExpanded] = useState(null);

    const handleClick = (id) => {
        // 🔹 Call backend to persist read state
        if (onMarkAsRead) {
            onMarkAsRead(id);
        }

        // 🔹 Update local state
        setReadNotifications((prev) => new Set(prev).add(id));

        // 🔹 Toggle expanded
        setExpanded(expanded === id ? null : id);
    };

    if (!responses || responses.length === 0) {
        return (
            <div style={{ padding: '10px', textAlign: 'center', color: '#666' }}>
                No admin notifications
            </div>
        );
    }

    return responses.map((n) => {
        const isRead = readNotifications.has(n.notification_id);
        const isExpanded = expanded === n.notification_id;

        return (
            <div
                key={n.notification_id}
                onClick={() => handleClick(n.notification_id)}
                style={{
                    padding: '10px 12px',
                    background: isRead ? '#ffe0e0' : '#fff5f5',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    cursor: 'pointer',
                    transition: 'background 0.2s'
                }}
            >
                <div style={{ fontWeight: '500', color: '#b91c1c' }}>{n.message}</div>
                <div style={{ fontSize: '0.85rem', color: '#555' }}>
                    {new Date(n.created_at).toLocaleString()}
                </div>

                {isExpanded && n.type && (
                    <div style={{ marginTop: '8px', fontSize: '0.85rem', color: '#b91c1c' }}>
                        <strong>Type:</strong> {n.type.replace('_', ' ').toUpperCase()}
                    </div>
                )}
            </div>
        );
    });
};

export default AdminResponse;
